import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBadges from './components/TrustBadges';
import CategoryGrid from './components/CategoryGrid';
import QualitySection from './components/QualitySection';
import ProductShowcase from './components/ProductShowcase';
import ComplianceSection from './components/ComplianceSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import { Link } from 'react-router-dom';
import { useSEO, generateOrganizationSchema, generateWebPageSchema } from '../../utils/seo';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Research Peptides Supplier | COA-Backed Biotech Compounds for Labs',
    description: 'Source research-grade peptides and biotech compounds with COA documentation, batch tracking, and quote-based ordering. Built for laboratories, universities, and research teams.',
    keywords: 'research peptides supplier, biotech compounds, COA peptides, laboratory peptide sourcing, research grade peptides, peptide supplier for labs, biotech research supply',
    canonical: `${siteUrl}/`,
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateOrganizationSchema(siteUrl),
        generateWebPageSchema(siteUrl, '/', 'Research Peptides Supplier | COA-Backed Biotech Compounds for Labs', 'Source research-grade peptides and biotech compounds with COA documentation, batch tracking, and quote-based ordering. Built for laboratories, universities, and research teams.')
      ]
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <h1 className="sr-only">DN Biotech - Research Peptides Supplier</h1>
      <HeroSection />
      <TrustBadges />
      <CategoryGrid />
      <QualitySection />
      <ProductShowcase />
      
      {/* How to Order Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-navy-900 mb-4">
              Simple Quote-Based Ordering
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our streamlined process ensures you receive accurate pricing and personalized service for your research needs
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white rounded-xl p-8 shadow-md text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-primary-600">1</span>
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3">Browse & Select</h3>
              <p className="text-gray-600">
                Explore our catalog and select the research peptides you need
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-md text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-primary-600">2</span>
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3">Request Quote</h3>
              <p className="text-gray-600">
                Submit an inquiry or message us on WhatsApp for pricing and availability
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-md text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-primary-600">3</span>
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3">Confirm & Receive</h3>
              <p className="text-gray-600">
                Confirm your order, complete payment, and receive door-to-door delivery
              </p>
            </div>
          </div>

          <div className="text-center">
            <Link
              to="/how-to-order"
              className="inline-flex items-center px-8 py-3 bg-navy-900 text-white font-semibold rounded-lg hover:bg-navy-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              View Complete Ordering Process
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      <ComplianceSection />
      <TestimonialSection />
      <CTASection />
      <Footer />
    </div>
  );
}